import { Routes } from '@angular/router';
import { WebsiteAdminSigninComponent } from './features/auth/website-admin-signin/website-admin-signin';
import { dashboardGuestGuard, dashboardRoleGuard } from 'sham-components/services';

export const routes: Routes = [
  {
    path: 'login',
    canActivate: [dashboardGuestGuard('WebsiteAdmin', ['/app'])],
    component: WebsiteAdminSigninComponent,
  },
  { path: 'website/login', redirectTo: 'login', pathMatch: 'full' },
  {
    path: 'login-media',
    canActivate: [dashboardRoleGuard('WebsiteAdmin', ['/login'])],
    loadComponent: () =>
      import('./features/auth-media/login-media/login-media-list/login-media-list').then(
        (x) => x.LoginMediaList,
      ),
  },
  {
    path: 'app',
    canActivate: [dashboardRoleGuard('WebsiteAdmin', ['/login'])],
    canActivateChild: [dashboardRoleGuard('WebsiteAdmin', ['/login'])],
    loadComponent: () =>
      import('./layouts/dashboard/dashboard').then((x) => x.Dashboard),
    loadChildren: () => import('./shared/dashboard-routes'),
  },
  {
    path: '',
    redirectTo: '/login',
    pathMatch: 'full',
  },
  {
    path: '**',
    redirectTo: '/login',
  },
];
